import { FEELING } from "../Constants";
import SmileyDull from "../Resources/Images/ic_smiley_down_dull.png";
import SmileyFine from "../Resources/Images/ic_smiley_fine.png";
import SmileyHappy from "../Resources/Images/ic_smiley_happy.png";
import SmileyOk from "../Resources/Images/ic_smiley_ok.png";
import SmileySad from "../Resources/Images/ic_smiley_sad.png";
import { VALIDATION_CONSTANTS } from "../Constants";
import { PhoneNumberUtil } from "google-libphonenumber";
import { PLATFORM } from "../Communication/Constants";


export default class CommonUtils {
  /**
   * Method used to get current timezone.
   */
  static getTimezone() {
    let commonInfo = {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    return commonInfo;
  }

  /**
   * Method to check if given string is empty or null.
   */

  /**
   * This function is introduced because of invite flow.
   * In invitation handling, we get token related information in verify/token API.
   * And we need to use that in further calls. So we have copied this info in userInfo
   * so that it can be used by other APIs without change
   *
   * @param {*} state
   */
  static getInvitedTokenInfo(state) {
    if (
      state.InvitationHandler.accessInfo &&
      state.InvitationHandler.accessInfo.isInvitedUser
    ) {
      let inviteInfo = {
        id: state.InvitationHandler.accessInfo.id,
        accessToken: state.InvitationHandler.accessInfo.accessToken,
      };
      return inviteInfo;
    } else {
      if (
        state.OtpVerification.currentUserInfo &&
        state.OtpVerification.currentUserInfo.id !== ""
      ) {
        return state.OtpVerification.currentUserInfo;
      } else {
        return state.Login.currentUserInfo;
      }
    }
  }

  static isStringNilOrEmpty(string) {
    let value = false;

    if (string === undefined || string === "") {
      value = true;
    }

    return value;
  }

  // Method to validate email.
  static isEmailValid(email) {
    let isEmailValid = true;

    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (reg.test(email) === false) {
      isEmailValid = false;
    }

    return isEmailValid;
  }

  /**
   * Method to find color of item according to index and return it.
   */

  /**
   * Returns image resouce for received emotion id.
   */
  static getImageResourceByEmotionId(emotionId) {
    let currentFeelingImg = undefined;

    if (emotionId === FEELING.Happy) {
      currentFeelingImg = SmileyHappy;
    } else if (emotionId === FEELING.Fine) {
      currentFeelingImg = SmileyFine;
    } else if (emotionId === FEELING.Ok) {
      currentFeelingImg = SmileyOk;
    } else if (emotionId === FEELING.DownDull) {
      currentFeelingImg = SmileyDull;
    } else if (emotionId === FEELING.Sad) {
      currentFeelingImg = SmileySad;
    }

    return currentFeelingImg;
  }
  
  static isNumberValid(inputNumber) {
    var phoneno = /^(([0-9]*)|(([0-9]*)([0-9]*)))$/;
    return phoneno.test(inputNumber);
}

//utility
  
static isUserNameValid(userName) {
  //let isValid = /^[A-Za-z0-9 _]+$/.test(userName.trim());
  let isValid = /^[A-Za-z ]+$/.test(userName.trim());
  return isValid;
}

static isValidNumber(mobileNumber) {
  return /^\d+$/.test(mobileNumber);
}

static isMobileValid(mobileNumber) {
  return !mobileNumber.trim().match("^[0]+$") && mobileNumber.trim().match("^[0-9]*$")
      && (mobileNumber.trim().length === VALIDATION_CONSTANTS.mobileNumberMinLength);
}

static isMobileWithCountryCodeValid(mobileNumberWithCountryCode) {
  try {
      const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
      const parsedNumberWithCode = phoneUtil.parse(mobileNumberWithCountryCode)
      return phoneUtil.isValidNumber(parsedNumberWithCode)
  } catch (exception) {
      return false
  }
}
static isAddressValid(value) {
  return value.trim().length > 0;
}

// static isEmailAddressValid = (emailAddress) => {
//   return EmailValidator.validate(emailAddress);
// }

static isCouponCodeValid(couponCode) {
  let isValid = /^[A-Za-z0-9 _]+$/.test(couponCode.trim());
  return isValid;
}


  /**
   * Returns emotion text/title for received emotion id.
   */
  static getEmotionTextByEmotionId(emotionId) {
    let currentFeelingText = "";

    if (emotionId === FEELING.Happy) {
      currentFeelingText = "Happy";
    } else if (emotionId === FEELING.Fine) {
      currentFeelingText = "Fine";
    } else if (emotionId === FEELING.Ok) {
      currentFeelingText = "OK";
    } else if (emotionId === FEELING.DownDull) {
      currentFeelingText = "Down";
    } else if (emotionId === FEELING.Sad) {
      currentFeelingText = "Sad";
    }

    return currentFeelingText;
  }

  // Method to get initials from first name and last name.
  static getInitials(firstName, lastName) {
    let initials = "";

    if (firstName != null) {
      initials = firstName
        .trim()
        .replace(/\W*(\w)\w*/g, "$1")
        .toUpperCase();
      if (firstName.length > 2) {
        initials = initials.substring(0, 2);
      }
    }

    if (lastName != null) {
      let temp = lastName
        .trim()
        .replace(/\W*(\w)\w*/g, "$1")
        .toUpperCase();
      if (lastName.length > 2) {
        temp = temp.substring(0, 2);
      }
      initials += temp;
    }

    return initials;
  }

  /**
   * Function to getInitials provided by strings(name)
   */
  static getFirstCharacter(name) {
    let initials = name.replace(/\W*(\w)\w*/g, "$1").toUpperCase();
    if (initials.length > 2) {
      initials = initials.substring(0, 2);
    }
    return initials;
  }

  static Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  /**
   * Method to convert milleseconds value into hours and minutes
   */
  static convertMS(milliseconds) {
    let day, hour, minute, seconds;
    seconds = Math.floor(milliseconds / 1000);
    minute = Math.floor(seconds / 60);
    seconds = seconds % 60;
    hour = Math.floor(minute / 60);
    minute = minute % 60;
    day = Math.floor(hour / 24);
    hour = hour % 24;
    let duration = "";
    if (hour > 0) {
      duration = duration.concat(hour + " ");
    }
    if (minute > 0) {
      duration = duration.concat(minute);
    }
    return duration;
  }

  static isMobileWithCallingCodeValid(mobileNumberWithCallingCode) {
    try {
      const phoneUtil = PhoneNumberUtil.getInstance();
      const parsedNumberWithCode = phoneUtil.parse(mobileNumberWithCallingCode);
      return phoneUtil.isValidNumber(parsedNumberWithCode);
    } catch (exception) {
      return false;
    }
  }

  static getColorByIndex (index, colors) {
    let position = index + 1;
    let colorListLength = colors.length;
    if (position > colorListLength) {
      position = position % colorListLength;
    }
    let indexColor = colors[0];
    for (let loopCounter = colorListLength; loopCounter > 0; loopCounter--) {
      let remainder = position % loopCounter;
      if (remainder === 0) {
        indexColor = colors[loopCounter - 1];
        break;
      }
    }
    return indexColor;
  }

  static handleRedirection (status, deviceType) {
    let intentURL = "";
    let iosURL = "";

    if (status === "success") {
      // console.log('success!');
      if (deviceType === PLATFORM.ANDROID) {
        // console.log('android');
        intentURL = "intent://allwellapp.com/?status=success#Intent;scheme=allwellnewsubscription-deeplink;package=com.atman.allwell;end";
        window.location.replace(intentURL);
      }
      else if (deviceType === PLATFORM.IOS) {
        // console.log('ios');
        iosURL = "allwellnewsubscription-deeplink://success";
        window.location.replace(iosURL);
      }
    }
    else if (status === "fail") {
      // console.log('failure!');
      if (deviceType === PLATFORM.ANDROID) {
        // console.log('android');
        intentURL = "intent://allwellapp.com/?status=fail#Intent;scheme=allwellnewsubscription-deeplink;package=com.atman.allwell;end";
        window.location.replace(intentURL);
      }
      else if (deviceType === PLATFORM.IOS) {
        // console.log('ios');
        iosURL = "allwellnewsubscription-deeplink://fail";
        window.location.replace(iosURL);
      }
    }
  }
}
